import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42b701f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "Byt vem du vill företräda", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-2 font-weight-bold px-2" }, "Du företräder:", -1))
const _hoisted_3 = { class: "text-subtitle-2" }
const _hoisted_4 = { class: "text-subtitle-2 pr-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "Logga ut", -1))

import { useAuthStore } from '@/stores/authStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'info-bar',
  setup(__props) {

const AuthStore = useAuthStore()

function logoutRedirect () {
  AuthStore.isAuthenticated = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!

  return (_openBlock(), _createBlock(_component_v_toolbar, {
    app: "",
    flat: "",
    color: "secondary",
    density: "compact",
    height: "60",
    id: "statusNav"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_link, {
        to: "/",
        class: "link"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            plain: "",
            "prepend-icon": "mdi-arrow-left",
            class: "text-subtitle-2 ml-0 px-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(AuthStore).setRepresentative('', '')))
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(AuthStore).getRepresentativeObject.name ? _unref(AuthStore).getRepresentativeObject.name : 'Ej möjligt att hämta namn'), 1),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_avatar, {
        color: "white",
        size: "28",
        class: "ma-2 text-body-2"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(AuthStore).getUserInitials), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("strong", null, " Inloggad som: " + _toDisplayString(_unref(AuthStore).getFirstName), 1)
      ]),
      _createVNode(_component_v_btn, {
        plain: "",
        class: "text-subtitle-2 mr-2 px-2",
        onClick: logoutRedirect
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})